import styled, { css } from "styled-components/macro"
import theme from "theme"

export const DayWrap = styled.div`
  font-size: 12px;
  color: #333;
  height: 28px;
  line-height: 28px;
  cursor: pointer;

  &:hover {
    background: #ffe8dc;
  }

  ${p =>
    p.outside &&
    css`
      color: #999;
    `};
  ${p =>
    p.today &&
    css`
      background: #f2f2f2;

      &:hover {
        background: #ffe8dc;
      }
    `};
  ${p =>
    p.active &&
    css`
      background: ${theme.color.red};
      color: #fff;
      &:hover {
        background: ${theme.color.red};
        color: #fff;
      }
    `};

  ${p =>
    p.blocked &&
    css`
      pointer-events: none;
      opacity: 0.5;
    `};
`
